<div class="{{ getStyles() }} flex items-center justify-center rounded-2xl font-semibold tracking-tight px-4 py-1">
  {{ severity| titlecase }}
</div>
